module.exports = __webpack_public_path__ + "img/wink-placeholder.85b6b1f6.png";